import { create } from 'zustand';

export type ChatChannel = 'world' | 'guild' | 'party' | 'nearby' | 'system';

export interface ChatMessage {
  id: number;
  channel: ChatChannel;
  from: string;
  text: string;
  ts: number;
}

interface ChatState {
  messages: ChatMessage[];
  active: ChatChannel;
  push: (m: Omit<ChatMessage, 'id' | 'ts'>) => void;
  setActive: (c: ChatChannel) => void;
  clear: () => void;
}

let mid = 0;

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  active: 'world',
  push: (m) => set((s) => ({
    messages: [...s.messages.slice(-199), { ...m, id: ++mid, ts: Date.now() }],
  })),
  setActive: (c) => set({ active: c }),
  clear: () => set({ messages: [] }),
}));
